import { render } from "./ModalVisualisarImagem.vue?vue&type=template&id=37619aa0"
import script from "./ModalVisualisarImagem.vue?vue&type=script&lang=js"
export * from "./ModalVisualisarImagem.vue?vue&type=script&lang=js"

import "./ModalVisualisarImagem.vue?vue&type=style&index=0&id=37619aa0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__